module.exports = __webpack_public_path__ + "static/img/sr_avatar.5ce4523c.jpg";